<ng-container *ngIf="display$ | async as display">
  <div
    class="backdrop"
    fxLayoutAlign="center center"
    [class.open]="display === true"
    (click)="close()"
  >
    <div class="modal-wrapper" (click)="$event.stopPropagation()">
      <h3>{{ data.title | translate }}</h3>
      <p>{{ data.content | translate }}</p>
      <div fxLayoutAlign="center center">
        <lns-button
          *ngFor="let btn of data?.buttons"
          (clickEvent)="modalAction(btn.action)"
          [buttonContent]="btn"
          >{{ btn.title | translate }}</lns-button
        >
      </div>
    </div>
  </div>
</ng-container>
